module.exports = __webpack_public_path__ + "static/lyon-530348ae21e0b9ba583538ae8df139f0.svg";